module.exports = "/images/laser tag (flatten-working).svg?df068b49a94dd6185f86538c09ee6032";